// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3UvT1","requiredAsterisk":"Info_requiredAsterisk__3WXA4"};